export const onInViewport = ( component, callback ) => (
    () => {
        const componentPosition = component.getBoundingClientRect();
        const viewportCenter = window.innerHeight / 2;

        if ( componentPosition.top - viewportCenter <= 0
            && componentPosition.bottom - viewportCenter >= 0
        )
        {
            component.classList.add( 'animate-component' );
            callback();
        } 
    }
);
